import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DotNetOutlinedSvg from "@ant-design/icons-svg/es/asn/DotNetOutlined";
import AntdIcon from "../components/AntdIcon";
var DotNetOutlined = function DotNetOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DotNetOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DotNetOutlined.displayName = 'DotNetOutlined';
}
export default /*#__PURE__*/React.forwardRef(DotNetOutlined);